import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'

import 'nprogress/nprogress.css'

Vue.use(Router)

let router = new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'List',
            component: () => import( /* webpackChunkName: "detail" */ './views/List.vue')
        },
        {
            path: '/list',
            name: 'List',
            component: () => import( /* webpackChunkName: "detail" */ './views/List.vue')
        },
        {
            path: '/detail',
            name: 'Detail',
            component: () => import( /* webpackChunkName: "detail" */ './views/Detail.vue')
        }, 
        {
            path: '/apply',
            name: 'Apply',
            component: () => import( /* webpackChunkName: "detail" */ './views/Apply.vue')
        }
    ]
})

router.beforeEach((to, from, next) => {
    NProgress.start()
    next()
})

router.afterEach(() => {
    NProgress.done()
})

export default router = router;
